/**
 * Created by tofael on 3/21/17.
 */

import 'whatwg-fetch';
import config from './app-config';
import {getToken} from './local-storage';

let checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    throw response;
  }
};

let parseJSON = (response) => {
  return response.json()
};

let _parseError = (error) => {
  if (error.json) {
    return error.json()
      .then((res)=>{
        throw res;
      })
  }
  throw error;
};

let request = (requestObj)=>{
  const {url, method, body} = requestObj;
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  if (getToken()) {
    headers.Authorization = `Bearer ${getToken()}`;
  }

  return fetch(`${config.urls.api_url}/${url}`, {
    method: method,
    headers: headers,
    body: body ? JSON.stringify(body) : null
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(_parseError);
};

let submitForm = (requestObj)=>{
  let {url, data, method='post'} = requestObj;
  let auth = `Bearer ${localStorage.getItem('token')}`;

  return fetch(`${config.urls.api_url}/${url}`, {
    method: method,
    headers: {
      'Authorization':auth
    },
    body: data
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(_parseError);
};

export default {
  request,
  submitForm
}


// WEBPACK FOOTER //
// ./src/utility/ajax.js